import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { navList } from './nav-list';
import { Icon } from '../../../shared';
import './nav.scss';
import { services } from '../../../../shared';
export var Nav = function (_a) {
    var _b;
    var visible = _a.visible, toggleVisible = _a.toggleVisible;
    var navClasses = 'c-site-nav';
    var _c = useState(), lendingCriteria = _c[0], setLendingCriteria = _c[1];
    if (visible) {
        navClasses += ' isActive';
    }
    if (!lendingCriteria)
        services.getModuleText('[LENDING-CRITERIA]__OTHER_TEXTS').then(function (res) { return setLendingCriteria(res.data); });
    return (React.createElement("nav", { className: navClasses },
        React.createElement("header", { className: "c-site-nav__title" },
            React.createElement("h2", null, "Navigation"),
            React.createElement("button", { type: "button", className: "c-site-nav__close", onClick: function () { return toggleVisible(!visible); } },
                React.createElement(Icon, { name: "chevronLeft" }))),
        React.createElement("ul", { className: "c-site-nav__list" },
            navList.map(function (link) { return (React.createElement("li", { key: link.linkName, className: "c-site-nav__item" },
                React.createElement(NavLink, { to: link.linkPath, className: "c-site-nav__link", activeClassName: "isActive", onClick: function () { return toggleVisible(!visible); } },
                    React.createElement(Icon, { name: link.icon }),
                    React.createElement("span", null, link.linkName)))); }),
            lendingCriteria && ((_b = lendingCriteria.description) === null || _b === void 0 ? void 0 : _b.length) > 0 && (React.createElement("li", { key: "lending criteria", className: "c-site-nav__item" },
                React.createElement("a", { target: "_blank", rel: "noreferrer", href: lendingCriteria.description, className: "c-site-nav__link" },
                    React.createElement(Icon, { name: "lendingcriteria" }),
                    React.createElement("span", null, "Lending Criteria")))))));
};
